var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaintBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71944 2C10.271 2 11.5288 3.2468 11.5288 4.78481V7.07826L17.0985 12.5993C17.5211 13.0182 17.4922 13.7057 17.036 14.0884L9.92792 20.0504C9.11672 20.7308 7.91481 20.6812 7.16342 19.9364L2.59844 15.4113C1.84705 14.6665 1.79705 13.4751 2.48345 12.6709L5.91009 8.65665V4.78481C5.91009 3.2468 7.16788 2 8.71944 2ZM9.99642 4.78481C9.99642 4.08572 9.42469 3.51899 8.71944 3.51899C8.01418 3.51899 7.44246 4.08572 7.44246 4.78481V6.86149L8.49797 5.62496C8.88288 5.17404 9.57346 5.14428 9.99642 5.55929V4.78481ZM9.48562 10.8608C9.48562 11.5599 10.0573 12.1266 10.7626 12.1266C11.4679 12.1266 12.0396 11.5599 12.0396 10.8608C12.0396 10.1617 11.4679 9.59494 10.7626 9.59494C10.0573 9.59494 9.48562 10.1617 9.48562 10.8608Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9353 22C20.6279 22 22 20.4887 22 18.6245C22 17.3247 20.5102 15.5402 19.608 14.5787C19.2399 14.1863 18.6306 14.1863 18.2625 14.5787C17.3603 15.5402 15.8705 17.3247 15.8705 18.6245C15.8705 20.4887 17.2426 22 18.9353 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintBucket);
export default __webpack_public_path__ + "static/media/paint-bucket.2aba9757865e866ba70f33784027241e.svg";
export { ForwardRef as ReactComponent };